/**
 * Vistazo rápido de categoría (Optioutlet).
 *
 * Al tocar una tarjeta de categoría en el inicio abre una ventana con los
 * tres primeros modelos y un botón para ver la categoría completa. La idea
 * es que nadie aterrice de golpe en una parrilla de diez y se congele.
 *
 * Los datos ya vienen en la página: collection-card.liquid siembra un
 * <script type="application/json"> dentro de cada tarjeta, así que abrir
 * no pide nada a la red.
 *
 * Con tres modelos o menos no se abre nada: la ventana mostraría la
 * categoría entera y sería un clic de más. En esos casos la tarjeta se
 * comporta como el enlace que siempre fue.
 */
const MINIMO = 3;
const SECCIONES = '[id$="__mundos"], [id$="__efectos"]';

let dialogo = null;
let origen = null;

function construir() {
  if (dialogo) return dialogo;
  dialogo = document.createElement('dialog');
  dialogo.className = 'ol-vistazo';
  dialogo.setAttribute('aria-labelledby', 'ol-vistazo-titulo');
  dialogo.innerHTML = `
    <button type="button" class="ol-vistazo__cerrar" aria-label="Cerrar">&times;</button>
    <header class="ol-vistazo__encabezado">
      <p class="ol-vistazo__antetitulo" data-conteo></p>
      <h2 class="ol-vistazo__titulo" id="ol-vistazo-titulo"></h2>
    </header>
    <ul class="ol-vistazo__lista" data-lista></ul>
    <a class="button ol-vistazo__todos" data-todos></a>
  `;
  document.body.append(dialogo);

  dialogo.querySelector('.ol-vistazo__cerrar').addEventListener('click', () => dialogo.close());
  // Clic en el fondo: el dialogo ocupa toda la pantalla, así que se mira
  // si el punto cae fuera de su caja de contenido.
  dialogo.addEventListener('click', (evento) => {
    if (evento.target !== dialogo) return;
    const r = dialogo.getBoundingClientRect();
    const dentro = evento.clientX >= r.left && evento.clientX <= r.right
      && evento.clientY >= r.top && evento.clientY <= r.bottom;
    if (!dentro) dialogo.close();
  });
  dialogo.addEventListener('close', () => origen?.focus({ preventScroll: true }));
  return dialogo;
}

const escapar = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

function abrir(datos, disparador) {
  const d = construir();
  origen = disparador;

  d.querySelector('.ol-vistazo__titulo').textContent = datos.titulo;
  d.querySelector('[data-conteo]').textContent =
    datos.total === 1 ? '1 modelo' : `${datos.total} modelos`;

  d.querySelector('[data-lista]').innerHTML = datos.productos.map((p) => `
    <li class="ol-vistazo__item">
      <a class="ol-vistazo__enlace" href="${escapar(p.url)}">
        <img class="ol-vistazo__foto" src="${escapar(p.imagen)}" alt="${escapar(p.alt)}" loading="lazy" width="420" height="420">
        <span class="ol-vistazo__nombre">${escapar(p.titulo)}</span>
        <span class="ol-vistazo__precio">
          ${escapar(p.precio)}
          ${p.rebajado > 0 ? `<s class="ol-vistazo__antes">${escapar(p.antes)}</s>` : ''}
        </span>
      </a>
    </li>`).join('');

  const todos = d.querySelector('[data-todos]');
  todos.href = datos.url;
  todos.textContent = `Ver los ${datos.total} modelos`;

  d.showModal();
}

document.addEventListener('click', (evento) => {
  // Clic con modificador o con la rueda: que el navegador haga lo suyo
  // (pestana nueva, ventana nueva). Interceptarlo seria quitarle algo.
  if (evento.metaKey || evento.ctrlKey || evento.shiftKey || evento.altKey || evento.button !== 0) return;

  const enlace = evento.target.closest('.collection-card__link');
  if (!enlace || !enlace.closest(SECCIONES)) return;

  const tarjeta = enlace.closest('.collection-card');
  const crudo = tarjeta?.querySelector('.ol-vistazo-datos');
  if (!crudo) return;

  let datos;
  try {
    datos = JSON.parse(crudo.textContent);
  } catch {
    return; // sin datos utiles, que siga siendo un enlace
  }
  if (!datos.productos?.length || datos.total <= MINIMO) return;

  evento.preventDefault();
  abrir(datos, enlace);
});
